<template>
    <div id="wrapper">        
        <router-view :key="reload" />
    </div>
</template>

<script>
    export default {
        name: 'loginLayout',
        data() {
            return {}
        },
        components: {},
        mounted() {},
        methods: {}
    }
</script>
